import React, {Fragment} from 'react';
import './styles.scss';
import { Redirect, Route, Switch, Link } from 'react-router-dom/es';
import { connect } from "react-redux";

import PrivateRoute from 'signoxe/containers/PrivateRoute';
import { AppPage, AssetsPage, TemplatePage } from 'signoxe/containers';
import { NotFoundPage } from '..';
import { Box, Page } from '../layout';
import { getProfile } from "signoxe/selectors";

import {Button, Icon} from 'signoxe/components/widgets';

const paths = {
    ASSET: '/assets',
    APPS: '/assets/apps',
    TEMPLATES: '/assets/templates',
    CHECKER:'/checker'
}

class AssetWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            isLoading:true,
        }
    }

    // static propTypes = {
    //     onDrop: PropTypes.func.isRequired,
    //     selectUploadFiles: PropTypes.func.isRequired,
    //     startUploadFile: PropTypes.func.isRequired
    // };

    checkActive(path){
        console.log(this.props.location.pathname, path)
        if (this.props.location.pathname === path){
            return 'active'
        }
        return ''
    }

    toggleFloat(){
        this.setState({visible: !this.state.visible})
    }

    render() {
        const { profile } = this.props;

        const activePath = this.props.location.pathname
        const { visible } = this.state;
        const isMakerChecker = this.props.profile && this.props.profile.maker_checker
        return (
            <Page className='asset-wrapper'>
                <Fragment>
                <Box justifyContent="center" >
                    {/* <Box justifyContent="space-around" className='page-tab'>
                        <Link className={`${this.checkActive(paths.ASSET)}`} to="/assets">Assets</Link>
                        <Link className={`${this.checkActive(paths.APPS)}`} to="/assets/apps">Apps</Link>
                        <Link className={`${this.checkActive(paths.TEMPLATES)}`} to="/assets/templates">Templates</Link>
                    </Box> */}
                    <div className={`floater-div depth-2 ${!visible ? 'd-none': ''}`}>
                        <ul>
                           
                            <li onClick={()=>this.props.history.push('/assets')} className={`${this.checkActive(paths.ASSET)}`}>
                                Assets
                            </li>

                           {isMakerChecker &&
                            <li onClick={()=>this.props.history.push('/checker')} className={`${this.checkActive(paths.CHECKER)}`}>
                                Assets Management
                            </li>}
                            
                            <li onClick={() => this.props.history.push('/assets/apps')} className={`${this.checkActive(paths.APPS)}`}>
                                Apps
                            </li>


                            <li onClick={() => {
                                if (window.innerWidth < 750){
                                    this.props.history.push('/assets/new/web')
                                }
                                else { this.props.history.push('/assets/templates')}
                            }
                            } className={`${this.checkActive(paths.TEMPLATES)}`}>
                                Templates
                            </li>
                        </ul>
                    </div>
                    <div className='floater'>
                        <Button title="Toggle filter bar"
                            className={`floater-btn`}
                            onClick={() => this.toggleFloat()}>
                            <Icon name="ellipsis-h"
                                margin={0}
                                size="1.2rem"
                                color='white' />
                        </Button>
                        
                    </div>
                </Box>
                </Fragment>
                <Switch>
                    <PrivateRoute exact path="/assets" component={AssetsPage}/>
                    <PrivateRoute exact path="/assets/apps" component={AppPage} />
                    <PrivateRoute exact path="/assets/templates" component={TemplatePage} />
                    <Route component={NotFoundPage} />
                </Switch>
            </Page>
        )
    }
}

export default connect(
    (state, props) => {
      return {
     
        profile: getProfile(state),
      };
    },
    {
     
    }
  )(AssetWrapper);
  


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetWrapper/index.js